import { Link } from "react-router-dom";
const logoImg = "/logo-pi.webp";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Logo = ({ size = "md", className = "" }: LogoProps) => {
  const imgH = { sm: "h-10", md: "h-14", lg: "h-20" }[size];
  const imgPx = { sm: 40, md: 56, lg: 80 }[size];
  const titleSize = { sm: "text-sm", md: "text-base", lg: "text-xl" }[size];
  const subSize = { sm: "text-[10px]", md: "text-xs", lg: "text-sm" }[size];

  return (
    <Link to="/" className={`inline-flex items-center gap-2 group ${className}`}>
      <img
        src={logoImg}
        alt="ProImpact Carrosserie"
        className={`${imgH} w-auto object-contain`}
        width={imgPx}
        height={imgPx}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
      <div className="flex flex-col leading-tight">
        <span className={`${titleSize} font-bold text-primary`}>ProImpact</span>
        <span className={`${subSize} font-semibold text-muted-foreground`}>Carrosserie</span>
      </div>
    </Link>
  );
};

export default Logo;
